const columns = [
	{
		label: 'Program ID',
		msgKey: 'SWCC000255',
		prop: 'pgmId',
		width: 200,
		custom: true
	},
	{
		label: '프로그램명',
		msgKey: 'SWCC000256',
		prop: 'pgmName',
		width: 450
	},
	{
		label: '서비스',
		msgKey: 'SWCC000250',
		prop: 'serviceKind',
		width: 200
	},
	{
		label: 'Server Name',
		msgKey: 'SWCC000249',
		prop: 'serverName',
		width: 350
	},
	{
		label: '메인Flg',
		msgKey: 'SWCC000257',
		prop: 'mainFlg',
		width: 200
	},
	{
		label: 'Shop',
		msgKey: 'SWCC000248',
		prop: 'shopCd',
		width: 200
	},
	{
		label: '라인 명',
		msgKey: 'SWCC000254',
		prop: 'lineCd',
		width: 200
	}
];

export default columns;
